'use strict';

import address from './address';
import billing from './billing';
import multiship from './multiship';
import shipping from './shipping';
import validator from '../../validator';


function submitNationalityData() {
    var $nationalityForm = $('#dwfrm_singleshipping_shippingAddress');
    $.ajax({
        type: 'POST',
        url: $nationalityForm.attr('action'),
        data: $nationalityForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=dwfrm_singleshipping_shippingAddress_save'
    }).always(function (data) {
        $('#summary-form')[0].submit();
    });
}

// renders the nationality popup
function getPaypalPayDisplayNationality(){
    $.ajax({
        type: 'GET',
        url: Urls.applePayGetNationality,
        data: {},
        success: function (response) {
            modal.addCustomClass('apple-pay-nationality-popup');
            modal.renderContent(response);
        },
        error: function () {
            alert('something went wrong');
        }
    }).always(function (data) {
        validator.initForm('form[id="dwfrm_singleshipping_shippingAddress"]');
        $(document).on('click', '#dwfrm_singleshipping_shippingAddress_save', function(e) {
            e.preventDefault();
            submitNationalityData();
        });
    });	
}

function initializeNationalityPopin() {
    $(document).on('click', '#dwfrm_billing_save', function(e) {

        if ($('.order-summary-footer form').valid() && $(this).data('displaynationalitypopin') == true) {
            e.preventDefault();
            getPaypalPayDisplayNationality();
        }
    });
}

// Checkout Newsletter Optin Consent

function setProfilingConsentEnabled($profilingConsentPref, enabled) {
        const $statusRegion = $('[data-profiling-consent-status]');
        const wasEnabled = $profilingConsentPref.attr('aria-disabled') === 'false';
        const profilingConsentHintId = $('.profiling-consent-hint').attr('id');

        if (enabled === wasEnabled) {
            return;
        }

        $profilingConsentPref.attr('aria-disabled', enabled ? 'false' : 'true');

        if (enabled) {
            $profilingConsentPref.removeAttr('aria-describedby');
        } else {
            $profilingConsentPref.prop('checked', false);
            $profilingConsentPref.attr('aria-describedby', profilingConsentHintId);
        }

        if ($statusRegion.length) {
            $statusRegion.text(enabled
                ? $statusRegion.data('enabledText')
                : $statusRegion.data('disabledText'));
        }
}

const initializeOptinContainer = () => {
    const $paymentConsentPref = $('.checkout-newsletter-optional input[type="checkbox"]');

    setProfilingConsentEnabled($paymentConsentPref, false);

    if ($('.pt_checkout .hide-btn-container').length) {
        $('.pt_checkout .show-content-wrapper').remove();
    }

    // Keep checkbox keyboard accessible but prevent interaction when disabled
    $('.checkout-newsletter-optional').on( 'click keydown', 'input[type="checkbox"]', function (e) {
            const isDisabled = $(this).attr('aria-disabled') === 'true';
            const isBlockedKey = [' ', 'Spacebar'].includes(e.key);

            if (isDisabled && (e.type === 'click' || isBlockedKey)) {
                e.preventDefault();
            }
        }
    );

    // Checkbox toggle
    $('.checkout-newsletter-optin').on( 'click keydown', 'input[type="checkbox"]', function () {
            const $checkbox = $(this);
            const isChecked = $checkbox.prop('checked');
            const isMobile = window.innerWidth < 480;

            const $parentContainer = $checkbox.closest('.checkout-newsletter-optin');
            const hasShowContent =
                $('.pt_checkout .show-content-wrapper').length > 0;

            const $secondaryText = $parentContainer.find('.secondary-text');
            const $primaryText = $parentContainer.find('.primary-text');
            const $seeMore = $parentContainer.find('.see-more-consent');
            const $seeLess = $parentContainer.find('.see-less-consent');

            setProfilingConsentEnabled($paymentConsentPref, isChecked);

            // Desktop
            if (!isMobile) {
                $seeMore.removeClass('is-active');
                $seeLess.removeClass('is-active');
                $secondaryText.toggleClass('is-active', isChecked);
                return;
            }

            // Mobile without Show More button
            if (!hasShowContent) {
                $secondaryText.toggleClass('is-active', isChecked);
                return;
            }

            // Mobile with Show More button
            if (isChecked) {
                $primaryText.addClass('show-text');
                $seeMore.addClass('is-active');
            } else {
                $primaryText.removeClass('show-text');
                $seeMore.removeClass('is-active');
                $secondaryText.removeClass('is-active');
                $seeLess.removeClass('is-active');
            }
        }
    );

    // Show more content
    $(document).on('click', '.see-more-consent', function () {
        const $parentContainer = $(this).closest('.checkout-newsletter-optin');

        $(this).removeClass('is-active');
        $parentContainer.find('.secondary-text').addClass('is-active');
        $parentContainer.find('.see-less-consent').addClass('is-active');
    });

    // Show less content
    $(document).on('click', '.see-less-consent', function () {
        const $parentContainer = $(this).closest('.checkout-newsletter-optin');

        $(this).removeClass('is-active');
        $parentContainer.find('.secondary-text').removeClass('is-active');
        $parentContainer.find('.see-more-consent').addClass('is-active');
    });
};

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
export default {
    init: function () {
        address.init();
        initializeOptinContainer();
        if ($('.checkout-shipping').length > 0) {
            shipping.init();
        } else if ($('.checkout-multi-shipping').length > 0) {
            multiship.init();
        } else {
            billing.init();
        }

        //if on the order review page and there are products that are not available diable the submit order button
        if ($('.order-summary-footer').length > 0) {
            if ($('.notavailable').length > 0) {
                $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
            }

            initializeNationalityPopin();
        }

    }
};
